import {Link} from 'react-router-dom';

import './CSS/Menu.css';

/**
 * メニューのコンポーネントです。
 * @returns  React.FunctionComponent
 */
const Menu: React.FC = () => {
    return (
        <div id='menu'>
            <ul>
                <li>
                    <Link to='/'>ダッシュボード</Link>
                </li>
                <li>
                    <Link to='/apiKey'>APIキー確認</Link>
                </li>
                <li>
                    <Link to='/collections'>コレクション</Link>
                </li>
                <li>
                    <Link to='/surveilances'>監視</Link>
                </li>
                <li>
                    <Link to='/setting'>設定</Link>
                </li>
                <li>
                    <Link to='/logout'>ログアウト</Link>
                </li>
            </ul>
        </div>
    );
};

export default Menu;
